/**
 * DEPRECATED!
 * use ./text.ts
 */

const URL_PATERN = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;

export function wrapLinksInTag (text: string, target = '_blank'): string {
  return text.replace(/\</gim, '&lt').replace(/\>/gim, '&gt').replace(URL_PATERN, url => `<a href="${encodeURI(url)}" target="${target}">${url}</a>`);
}
